<template>
  <v-fade-transition mode="out-in">
    <v-icon
      @click="isDarkFun()"
    >
      {{ $vuetify.theme.dark ? icons.mdiWeatherSunny : icons.mdiWeatherNight }}
    </v-icon>
  </v-fade-transition>
</template>

<script>
import { mdiWeatherNight, mdiWeatherSunny } from '@mdi/js'
import useAppConfig from '@core/@app-config/useAppConfig'
import { updateTheme } from "@/api/index";
import { getVuetify } from '@core/utils'
import { getCurrentInstance } from '@vue/composition-api'
import { getCookie, setCookie } from '@/utils/cookie';

export default {
  setup() {
    const $vuetify = getVuetify()
    let eventHub = getCurrentInstance().proxy.$root.eventHub
    const isDarkFun = () => {
      let isDark = !$vuetify.theme.dark

      let params = {
        materioSkinVariant: isDark ? 1 : 0
      }
      updateTheme(params).then(res=> {
        if(res.code == 200) {
          $vuetify.theme.dark = isDark
          localStorage.setItem('materio-active-theme', isDark ? 'dark' : 'light')
          setCookie('materio-active-theme',isDark ? 'dark' : 'light')
          eventHub.$emit('changeDark')
        }
      })
    }
    return {

      // Icons
      icons: {
        mdiWeatherNight,
        mdiWeatherSunny,
      },
      isDarkFun
    }
  },
}
</script>

<style>
</style>
